// extracted by mini-css-extract-plugin
export default {"button":"ProductTourButton_button__2AEDK"};